<template>
    <div>           
        <barraaplicacion titulo="Unidades"></barraaplicacion> 
        <br><br>
        <v-container fluid>                  
            <v-row>
                <v-col>
                    <v-card-title dense>
                        <v-spacer></v-spacer>
                        <v-text-field dense v-model="busqueda" append-icon="mdi-magnify" label="Buscar" single-line hide-details> </v-text-field>
                    </v-card-title>
                    <v-data-table 
                        dense :headers="tabla_encabezado" 
                        :items="unidades"
                        :item-class="color_fondo"                        
                        :items-per-page="15"
                        class="elevation-1"
                        mobile-breakpoint="100"                       
                        multi-sort
                        :search="busqueda"   
                        loading-text="Consultando información..."
                        :loading="cargando"
                        no-data-text="No se encontró información."
                        locale="es-MX"
                        :footer-props="{
                            'items-per-page-text':'Unidades por página',
                            'items-per-page-all-text': 'Todas',
                            'show-current-page':true,
                            'show-first-last-page': true,                                                                                 
                            'page-text':page_text
                        }"
                        @pagination="texto_paginacion"                                         
                    >

                    <template v-slot:[`item.sucursal`]="{ item }">
                        <v-select class="select" @change='hadleChangeSucursal(item)' v-model="item.sucursal" :items="sucursales" placeholder="Sin asignar" outlined dense hide-details ></v-select>                  
                    </template>

                    <template v-slot:[`item.ACCIONES`]="{ item }">
                        <v-icon  class="mr-2" @click="editar_unidad(item)">
                            mdi-clipboard-pulse-outline
                        </v-icon>
                        <v-icon  class="mr-2" @click="log_unidad(item)">
                            mdi-notebook-outline
                        </v-icon>
                        <v-icon  class="mr-2" @click="handleDialogoImagen(item)">
                            mdi-camera-outline
                        </v-icon>
                    </template>                    

                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color='snackbar_color' ><strong>{{snackbar_msj}}</strong></v-snackbar>
        
        <v-dialog v-model="dialogo" persistent hide-overlay width="300">
            <div class="resaltar pa-6">
                <strong>{{dialogo_msj}}</strong>
                <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>    
            </div>
        </v-dialog>
        
        <v-dialog v-model="dialogo_estatus_unidad" persistent hide-overlay width="400">
            <div class="resaltar pa-6">
                <v-select :items="items_estatus" outlined label="Estatus" dense v-model="selecion_estatus"></v-select>
                <v-textarea v-model="comentarios_estatus" label="Comentarios" row-height="15" auto-grow outlined desne></v-textarea> 
                <div class="d-flex justify-end">                        
                    <v-btn color="success" outlined class="mr-2" @click="guarda">Guardar</v-btn>      
                    <v-btn color="error" outlined @click="dialogo_estatus_unidad=false">Cancelar</v-btn>      
                </div>   
            </div>
        </v-dialog>

        <v-dialog v-model="dialogo_historial" hide-overlay width="900">
            <div class="resaltar pa-6">    
                <v-container>
                    <div class="mb-5"><strong>{{item_seleccionado.ccamion}} {{item_seleccionado.descripcion}}</strong></div>
                    <v-row v-for="log of historial_unidad" :key="log.ccamion" dense>
                        <v-col cols="12" xs="12" sm="2" class="d-flex">
                            <v-chip class="black--text" :class="color_fondo_log(log.estatus)">{{log.estatus}}</v-chip>                            
                        </v-col>
                        <v-col cols="12" xs="12" sm="5" class="d-flex">
                            {{log.comentarios}}
                        </v-col>
                        <v-col cols="12" xs="12" sm="2" class="d-flex">
                            {{log.usuario}}
                        </v-col>
                        <v-col cols="12" xs="12" sm="2" class="d-flex">
                            {{log.fecha}}
                        </v-col>
                        <v-col cols="12" xs="12" sm="1" class="d-flex">
                            {{log.hora}}
                        </v-col>    
                        <v-col cols="12" class="pa-0">
                            <v-divider></v-divider>    
                        </v-col>                                          
                    </v-row>
                    
                </v-container>                     
                <div class="d-flex justify-end mt-3"> 
                    <v-btn color="error" outlined @click="dialogo_historial=false">Cerrar</v-btn>      
                </div>   
            </div>
        </v-dialog>

        <v-container>
            <v-dialog v-if="dialogoImagen" v-model='dialogoImagen' hide-overlay width="800">
                <v-card>
                    <v-card-title class="d-flex justify-center">{{unidadEditando.ccamion}}  {{unidadEditando.descripcion}}</v-card-title>
                    <v-card-text>
                        <b>Imagenes</b>
                    </v-card-text>

                    <v-card-text>
                        <v-row class="d-flex justify-center">
                            <v-progress-circular indeterminate v-if="cargandoImagenes"></v-progress-circular>
                        </v-row>                        
                        <div class="d-flex" style="overflow-x: auto;">
                            <div v-for="(imagen, key) of unidadImagenes" :key="key" class="ma-2 d-flex flex-column" >
                                    <a :href=imagen.imagen target="_blank"><v-img :src=imagen.imagen width="300px" /></a>
                                    <v-icon color="red" @click="handleEliminarImagen(unidadEditando.ccamion.trim(), imagen.id)">mdi mdi-delete-circle-outline</v-icon>
                            </div>   
                        </div>                     
                    </v-card-text>                   
                    
                    <v-card-text class="d-flex justify-center">
                        <v-progress-circular indeterminate v-if="subiendoImagenes"></v-progress-circular>
                        <v-file-input v-if="!subiendoImagenes" @change="handleChangeImagen" v-model="imagen" label="Agregar imágen" prepend-icon="" append-icon="mdi-cloud-upload" chips counter multiple dense outlined></v-file-input>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>

        <v-container>
            <dialogocarga mensaje='Actualizando...' :estatus="actualizandoUnidad" />
        </v-container>

    </div>
</template>
<script>
import axios from 'axios';
import cookie from 'vue-cookie';
import barraaplicacion from '@/components/BarraAplicacion'
import dialogocarga from '@/components/DialogoCarga'
export default {
    components:{
        barraaplicacion,
        dialogocarga
    },
    data() {
        return {
            token: Object,
            unidades: [],
            tabla_encabezado: [],
            busqueda: '',
            cargando: true,
            snackbar: false,
            snackbar_timeout: 3000,
            snackbar_color: '',
            snackbar_msj: '',
            page_text: '',
            
            dialogo: false,      
            dialogo_msj: '',  
           
            dialogo_estatus_unidad: false,
            items_estatus: ['ACTIVO', 'REVISIÓN', 'REPARACIÓN', 'PRESTADO'],
            selecion_estatus: '',
            comentarios_estatus: '',

            dialogo_historial: false,
            historial_unidad: [],
            
            item_seleccionado: Object,

            dialogoImagen:false,
            unidadEditando: null,
            subiendoImagenes: false,
            cargandoImagenes: false,
            unidadImagenes: [],
            imagen: null,

            sucursales: [
                {'value':'001', 'text': '001 Cedis Parral'},
                {'value':'000', 'text': '000 Cedis Chihuahua'},
                {'value':'200', 'text': '200 Surtace JPII'},
                {'value':'201', 'text': '201 Surtace Norte'},
                {'value':'202', 'text': '202 Surtace Centro'},
                {'value':'203', 'text': '203 Surtace Delicias'},
                {'value':'204', 'text': '204 Surtace Casas Grandes'},
                {'value':'900', 'text': '900 Dipar Chihuahua'},
                {'value':'901', 'text': '901 Dipar Torreon'},
                {'value':'902', 'text': '902 Surtace Cd. Juárez'},
            ],

            actualizandoUnidad: false, 

        }
    },

    methods: {

        color_fondo: function(item) {            
            if(item.foto !== '' &&  item.foto != null ){
                let estado = item.foto.trim()
                
                if(estado == 'PRESTADO')
                    return 'blue lighten-4'
                if(estado == 'REPARACIÓN')
                    return 'red lighten-4'
                if(estado == 'REVISIÓN')
                    return 'yellow lighten-4'
            }
        },

        color_fondo_log: function(estatus) {            
            if(estatus !== '' &&  estatus != null ){
                let estado = estatus.trim()

                if(estado == 'ACTIVO')
                    return 'green lighten-4'
                if(estado == 'PRESTADO')
                    return 'blue lighten-4'
                if(estado == 'REPARACIÓN')
                    return 'red lighten-4'
                if(estado == 'REVISIÓN')
                    return 'yellow lighten-4'
            }
        },

        texto_paginacion: function(pg){           
            this.page_text = 'Total unidades '+pg.itemsLength
        },

        editar_unidad: function(it){            
            this.dialogo_estatus_unidad = true
            this.item_seleccionado = it;
        },

        guarda: function() {
            if(this.selecion_estatus !=null && this.selecion_estatus != '' && this.selecion_estatus != this.item_seleccionado.foto && this.comentarios_estatus !=null && this.comentarios_estatus){
                this.dialogo_estatus_unidad = false
            
                let id_unidad = this.item_seleccionado.ccamion                
                this.dialogo = true;
                this.dialogo_msj = 'Realizando cambios...'

                axios.put(this.$url+'/taller/unidad/estatus', 
                        {"idunidad":id_unidad, "estatus":this.selecion_estatus, "comentarios":this.comentarios_estatus},
                        {headers:{Authorization: `Bearer ${this.token}`}}                       
                        
                )
                    .then((res)=>{
                        
                        this.dialogo = false;

                        let respuesta = res.data;

                        if(respuesta.estatus){ //Estatus actualizado
                            this.snackbar = true;
                            this.snackbar_msj = respuesta.mensaje;
                            this.snackbar_color = 'success white--text'
                            this.item_seleccionado.foto = this.selecion_estatus
                            this.comentarios_estatus = ''
                        }
                        else{
                            this.snackbar = true;
                            this.snackbar_msj = respuesta.mensaje;
                            this.snackbar_color = 'error black--text'
                        }

                    })
                    .catch((error)=>{
                        console.log("Error "+error);                    
                        this.dialogo = false;
                    })
            }
        },

        consultaUnidades: function(){            
            axios.get(this.$url+'/taller/unidades/activo', {headers:{Authorization: `Bearer ${this.token}`}})
                .then((res)=>{
                    let jsunidades = res.data;
                    this.cargando = false

                    for(let key in jsunidades[1]){
                        this.tabla_encabezado.push({text:key.toUpperCase(), value:key, class:"resaltar primary--text"})
                    }
                    this.tabla_encabezado.push({text:"ACCIONES", value:"ACCIONES", class:"resaltar primary--text"})

                    this.unidades = res.data;                    

                })
                .catch((error)=>{
                    this.cargando = false
                    console.log("Error "+error);
                })
        },

        log_unidad: function(it) {
            this.historial_unidad = []
            this.dialogo = true
            this.dialogo_msj = "Consultando historial"
            this.item_seleccionado = it;
          
            axios.get(this.$url+'/taller/unidad/historial-estatus/'+it.ccamion, 
                    {headers:{Authorization: `Bearer ${this.token}`}}
            )
                .then((res)=>{
                    
                    this.dialogo = false
                    this.dialogo_historial = true

                    let jslog = res.data;
                    
                    if(jslog.estatus){
                        this.historial_unidad = jslog.log
                    }
                    else{
                        console.log(jslog.mensaje);
                    }

                })
                .catch((error)=>{
                    this.dialogo = false
                    console.log("Error "+error);
                })
        },

        handleDialogoImagen(item){         
            
            const cuerpo = {
                'ccamion': item.ccamion,
                'imagen': 'imagen01'
            }
            
            this.dialogoImagen = true
            this.unidadEditando = item

            this.obtenerImagenes(item.ccamion)

        },

        obtenerImagenes(ccamion){
            this.cargandoImagenes = true
            this.unidadImagenes = []
            axios.get(this.$url+'/taller/unidades/imagen/'+ccamion, {headers:{Authorization: `Bearer ${this.token}`}})     
                .then((response)=>{
                    console.log(response.data);
                    this.unidadImagenes = response.data.imagenes
                })
                .catch((error)=>{
                    console.log(error);
                })
                .finally(()=>{
                    this.cargandoImagenes = false
                })
        },

        handleChangeImagen(){
            const archivo = this.imagen

            if(!archivo)
                return

            archivo.forEach(archivo => {
				this.enviarArchivo(archivo)
			});
        },

        enviarArchivo(archivo){

            if (archivo.type != 'application/pdf' && archivo.type != 'image/jpeg' && archivo.type != 'image/png') {   
                this.snackbartexto = "Tipo de archivo no valido..."
                this.snackbarcolor = 'error'
                this.snackbar = true
                return                   
            }           

            if( (archivo.size / 1024) > 5120 ){
                this.snackbartexto = "Archivo supera el tamaño maximo 5mb"
                this.snackbarcolor = "error"
                this.snackbar = true
                return
            }

            let data = new FormData();
            data.set('enctype', 'multipart/form-data')
            data.append("ccamion", this.unidadEditando.ccamion.trim())
            data.append("file", archivo)
            data.append('_method', 'POST')

            this.subiendoImagenes = true

            axios.post(this.$url+'/taller/unidades/imagen', data, {headers:{Authorization: `Bearer ${this.token}`}})                   
                .then((response)=>{
                    this.snackbar_color = 'success'
                    this.snackbar_msj = response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                    this.obtenerImagenes(this.unidadEditando.ccamion.trim())
                })
                .catch((error)=>{
                    this.snackbar_color = 'error'
                    this.snackbar_msj = error.response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                })
                .finally(()=>{
                    this.imagen = null
                    this.subiendoImagenes = false
                })
        },

        handleEliminarImagen(ccamion, imagen){
           
            axios.delete(this.$url+`/taller/unidades/imagen/${ccamion}&${imagen}`, {headers:{Authorization: `Bearer ${this.token}`}})     
                .then((response)=>{
                    this.snackbar_color = 'success'
                    this.snackbar_msj = response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                })
                .catch((error)=>{
                    this.snackbar_color = 'error'
                    this.snackbar_msj = error.response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                })
                .finally(()=>{
                    this.obtenerImagenes(ccamion)                    
                })

        },

        hadleChangeSucursal(unidad){

            const data = {
                'ccamion': unidad.ccamion,
                'sucursal': unidad.sucursal
            }

            this.actualizandoUnidad = true           
            axios.put(this.$url+'/taller/unidades/sucursal', data, {headers:{Authorization: `Bearer ${this.token}`}})     
                .then((response)=>{                   
                    this.snackbar_color = 'success'
                    this.snackbar_msj = response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                })
                .catch((error)=>{
                    this.snackbar_color = 'error'
                    this.snackbar_msj = error.response.data.mensaje
                    this.snackbar_timeout = 3000
                    this.snackbar = true
                })
                .finally(()=>{
                    this.actualizandoUnidad = false
                })
        }
    },

    created() {               
        this.token = cookie.get('token')        
        if(this.token ===  '' || this.token === null ){     
            this.$router.push({name:'Login'});
        }
        else{
            this.consultaUnidades()
        }
    },
}
</script>
<style>
    .select{
        width: 250px;
    }
</style>